import { render, staticRenderFns } from "./Salaries.vue?vue&type=template&id=10e882e2&scoped=true&"
import script from "./Salaries.vue?vue&type=script&lang=js&"
export * from "./Salaries.vue?vue&type=script&lang=js&"
import style0 from "./Salaries.vue?vue&type=style&index=0&id=10e882e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e882e2",
  null
  
)

export default component.exports